import { tenantsActions, tenantsReducers } from '@frontegg/redux-store';
import { reducerActionsGenerator, stateHookGenerator } from './hooks';
const defaultMapper = state => state;
export function useTenantsState(stateMapper = defaultMapper) {
  return stateHookGenerator(stateMapper, 'tenantsState');
}
export const useTenantsActions = () => reducerActionsGenerator(tenantsActions, tenantsReducers);